import React from "react";
import { useTranslation } from "react-i18next";
import { GetObject } from "../../../Redux/Reducers/redux-slice-asset";
import { GetTreeObj, TreeContext } from "../../../Redux/Reducers/redux-slice-tree";
import { useAppSelector } from "../../../Redux/redux-store";
import DrawerWrapper from "../../Drawers/Drawer/drawer-wrapper";
import PanelHeader from "../../Panels/PanelHeader/panel-header";
import AssetTreeView from "../TitleTreeView/asset-tree-view-2";
import { OutlinedInput } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";

export interface TitleTreeViewPanelProps {
  onClose: () => void;
  open: boolean;
}

const TitleTreeViewPanel: React.FC<TitleTreeViewPanelProps> = ({ onClose, open }) => {
  const { t } = useTranslation();
  // Redux
  const graph = useAppSelector(GetTreeObj(TreeContext.TitlePanel));
  const currentObj = useAppSelector(GetObject);

  const [searchValue, setSearchValue] = React.useState("");

  return (
    <DrawerWrapper
      open={open}
      onClose={onClose}
      anchor="left"
      width={500}
      header={
        <PanelHeader title={t("common:treeview")} onClose={onClose} placement="left">
          <OutlinedInput
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
            endAdornment={<SearchOutlined color="primary" />}
            placeholder={t("field:placeholder.treeviewSearch")}
            sx={{ width: "100%" }}
          />
        </PanelHeader>
      }
    >
      {graph && (
        <AssetTreeView
          rootObjectId={graph.id}
          currentAssetId={currentObj?.id}
          context={TreeContext.TitlePanel}
          searchTerm={searchValue}
          disableSelection
        />
      )}
    </DrawerWrapper>
  );
};

export default TitleTreeViewPanel;
